import * as React from "react";

import { Button } from "@alaffia-technology-solutions/ds";

import { X } from "lucide-react";

export const CloseButton = ({
  ref,
  children = <X className="af-h-4 af-w-4" />,
  ...props
}: React.ComponentProps<typeof Button>) => (
  <Button ref={ref} aria-label="Close" variant="ghost" size="icon" {...props}>
    {children}
  </Button>
);
CloseButton.displayName = "CloseButton";
